export default ({ eventBus, eventDefinitions, context }) => {
  eventBus.$on(eventDefinitions.PROMOTION.CLICK, ({ promotion }) => {
    //
  })
}
